// import theme
import {
  deepMerge,
  muiThemeOptions,
  planningMuiThemeOptions
} from '@sdb/planning-ui';
import { themeExtension } from './theme.extension';
import { createTheme, ThemeOptions } from '@mui/material/styles';

const baseOptions = deepMerge(
  muiThemeOptions as ThemeOptions, // we need to cast here, because TS does not infer the type here correctly
  planningMuiThemeOptions as ThemeOptions
);

export default createTheme(deepMerge(baseOptions, themeExtension));
